import * as actionTypes from '../action-types';
import {
  fetchWatchers,
  fetchWatcher,
  markAllWatcherDecisionsAsRead,
} from '../../watchers.api';
import {
  WatcherLight,
  NewWatcherFromSuggestionQueryParams,
} from '../../watchers.types';

const setWatcher = (watcher: WatcherLight) =>
  <const>{
    type: actionTypes.SET_WATCHER,
    payload: { watcher },
  };

const setWatchers = (watchers: Array<WatcherLight>) =>
  <const>{
    type: actionTypes.SET_WATCHERS,
    payload: { watchers },
  };

const deleteWatcher = (watcherKey: string) =>
  <const>{
    type: actionTypes.DELETE_WATCHER,
    payload: { watcherKey },
  };

const markDecisionAsRead = (watcherKey: string) =>
  <const>{
    type: actionTypes.SET_DECISION_AS_READ,
    payload: { watcherKey },
  };

const allDecisionsAsRead = (watcherKey: string) =>
  <const>{
    type: actionTypes.SET_ALL_DECISIONS_AS_READ,
    payload: { watcherKey },
  };

export const getWatcher = (watcherKey: string) => async (
  dispatch: Function,
) => {
  const watcher = await fetchWatcher(watcherKey);
  dispatch(setWatcher(watcher));
  return watcher;
};

export const getWatchersList = () => async (dispatch: Function) => {
  const watchers = await fetchWatchers({ from: 0 });
  dispatch(setWatchers(watchers));
};

export const addNewWatcherToList = (watcher: {
  key: string;
  searchQuery: NewWatcherFromSuggestionQueryParams;
}) =>
  <const>{
    type: actionTypes.CREATE_WATCHER,
    payload: { watcher: { ...watcher, numberOfNewDecisions: '0' } },
  };

export const removeWatcherFromList = (watcherKey?: string) => (
  dispatch: Function,
  getState: Function,
) => {
  const { watchers } = getState();
  if (watcherKey && watchers.keys.includes(watcherKey)) {
    dispatch(deleteWatcher(watcherKey));
  }
};

export const setDecisionAsRead = (watcherKey: string) => (
  dispatch: Function,
) => {
  dispatch(markDecisionAsRead(watcherKey));
};

export const setAllDecisionsAsRead = (watcherKey: string) => async (
  dispatch: Function,
) => {
  await markAllWatcherDecisionsAsRead(watcherKey);
  dispatch(allDecisionsAsRead(watcherKey));
};

export type WatchersActions = ReturnType<
  | typeof setWatcher
  | typeof setWatchers
  | typeof addNewWatcherToList
  | typeof deleteWatcher
  | typeof markDecisionAsRead
  | typeof allDecisionsAsRead
>;
